import {connect} from 'react-redux';
import navigate from 'Data/actionCreators/kiosk/navigate';
import hideCard from 'Data/actionCreators/kiosk/hideCard';
import SelectedItemPanel from './SelectedItemPanel';

export default connect(
    null,
    {
        hideCard,
        navigate,
    }
)(SelectedItemPanel);
